import { useIntl } from 'react-intl';
import { Col, Row, Select } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import { InputDate } from '@/components/_common';
import moment from 'moment';
import { ListNotificationsQuery } from '@/core/domain/notification/Notification/Notification.types';
import { DateTimeFormat } from '@/utils/moment';

function NotificationExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListNotificationsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} lg={3} md={3}>
        <InputDate
          placeholder={intl.formatMessage({
            id: 'notifications.table.DateAndTime',
          })}
          value={
            queryParams?.notificationDate
              ? moment(queryParams?.notificationDate)
              : undefined
          }
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              notificationDate: value?.format(DateTimeFormat),
            }))
          }
        />
      </Col>
      <Col span={24} lg={4} md={4}>
        <Select
          allowClear
          value={queryParams?.readed}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              readed: value,
            }))
          }
          style={{ width: '100%' }}
          placeholder="Notificação lida?"
        >
          <Select.Option value="true">Sim</Select.Option>
          <Select.Option value="false">Não</Select.Option>
        </Select>
      </Col>
    </Row>
  );
}

export default NotificationExtraFilters;
